import { render, staticRenderFns } from "./CollectionLoans.vue?vue&type=template&id=10ae5e09&lang=pug&"
import script from "./CollectionLoans.vue?vue&type=script&lang=js&"
export * from "./CollectionLoans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports